module.exports = __webpack_public_path__ + "media/images/common/detail-8fcb65e4e51a3785d233edcae9f69650.gif";